import type {
  PrV2CommentResponse,
  PrV2ReactionContent,
  PrV2ReactionSubjectType,
} from '@/lib/pr-v2/types';

type AuthLikeUser =
  | {
      identities?: Array<{
        id?: string | null;
      } | null> | null;
    }
  | null
  | undefined;

export function parsePositiveInteger(value: string | null | undefined): number | null {
  if (!value) {
    return null;
  }

  const parsed = Number.parseInt(value, 10);
  if (Number.isInteger(parsed) && parsed > 0) {
    return parsed;
  }

  return null;
}

export function normalizeReactionSubjectType(
  comment: Pick<PrV2CommentResponse, 'commentType' | 'reactionSubjectType'>,
): PrV2ReactionSubjectType {
  if (comment.reactionSubjectType === 'pull_request_review') {
    return 'pull_request_review';
  }

  return comment.commentType === 'issue_comment' ? 'issue_comment' : 'review_comment';
}

export function getCommentNumericId(
  comment: Pick<PrV2CommentResponse, 'githubCommentId'>,
): number | null {
  return parsePositiveInteger(comment.githubCommentId);
}

export function getCurrentUserGithubId(user: AuthLikeUser): number | null {
  return parsePositiveInteger(user?.identities?.[0]?.id);
}

export function getReactionKey(commentId: number, emoji: PrV2ReactionContent): string {
  return `${commentId}:${emoji}`;
}
